// LIBRARIES
// @ts-nocheck
import styled from "styled-components";

// MISC
import { COLORS, BOXSHADOW, FONTS, WIDTH } from "constants/styleVariables";
import { Tabs } from "models/GeneralTypes/generalTypes";


export const HeaderContainer = styled.div<{ activeTab?: string }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 80px;
  background-color: ${COLORS.primaryAppWhite};
  border-radius: 24px;
  margin-bottom: 24px;
  align-items: center;
  justify-content: space-between;
  padding-left: 32px;
  overflow-x: auto;
  
  @media (max-width: 1400px) {
    min-width: ${props => (props.activeTab === "reports" ||
    props.activeTab === "invoices" ||
    props.activeTab === "audit") ? "1200px" : "auto"}
  }
  
  @media (${WIDTH.tabletWidth}) {
    min-width: auto;
    padding-left: 16px;
    padding-right: 8px;
    border-radius: 16px;
    min-height: 70px;
    margin-bottom: 16px;
  }
  
  @media (max-width: 768px) {
    padding-left: 12px;
    padding-right: 4px;
    border-radius: 12px;
    min-height: 60px;
    margin-bottom: 12px;
  }
  
  @media (max-width: 480px) {
    padding-left: 8px;
    padding-right: 4px;
    min-height: 56px;
    margin-bottom: 8px;
  }
`;

export const IconsWrapper = styled.div`
  margin-right: 12px;
  margin-left: 40px;
  display: flex;
  align-items: center;
  
  @media (${WIDTH.tabletWidth}) {
    margin-left: 20px;
    margin-right: 8px;
  }
  
  @media (max-width: 768px) {
    margin-left: 12px;
    margin-right: 4px;
  }
  
  @media (max-width: 480px) {
    margin-left: 8px;
    margin-right: 4px;
  }
`;

export const MenuIcon = styled.img`
  margin-left: 25px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  
  @media (${WIDTH.tabletWidth}) {
    margin-left: 0;
    width: 22px;
    height: 22px;
  }
  
  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`;

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    margin-left: auto;
  }
`
export const Icon = styled.img`
  margin-right: 24px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  
  @media (${WIDTH.tabletWidth}) {
    margin-right: 16px;
    width: 22px;
    height: 22px;
  }
  
  @media (max-width: 768px) {
    margin-right: 12px;
    width: 20px;
    height: 20px;
  }
  
  @media (max-width: 480px) {
    margin-right: 8px;
    width: 18px;
    height: 18px;
  }
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  // margin-right: 32px;
`;

export const UserName = styled.div`
  font-size: 16px;
  color: ${COLORS.primaryAppBlack};
  font-family: ${FONTS.poppins};
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  
  @media (${WIDTH.tabletWidth}) {
    font-size: 14px;
    max-width: 120px;
  }
  
  @media (max-width: 768px) {
    font-size: 13px;
    max-width: 100px;
  }
`;

export const UserRole = styled.div`
  font-size: 12px;
  color: ${COLORS.primaryAppGray};
  font-family: ${FONTS.poppins};
  font-weight: 600;
  white-space: nowrap;
  
  @media (${WIDTH.tabletWidth}) {
    font-size: 11px;
  }
  
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const PageTitle = styled.div`
  width: 170px;
  height: 40px;
  border-radius: 16px;
  background-color: #293462;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: #F5F5F5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  @media (${WIDTH.tabletWidth}) {
    width: 140px;
    height: 36px;
    font-size: 14px;
    border-radius: 12px;
  }
  
  @media (max-width: 768px) {
    width: 120px;
    height: 32px;
    font-size: 12px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    width: 100px;
    height: 28px;
    font-size: 11px;
    border-radius: 8px;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const ButtonContainer = styled.div`
  margin-left: 32px;
  
  @media (${WIDTH.tabletWidth}) {
    margin-left: 16px;
  }
  
  @media (max-width: 768px) {
    margin-left: 8px;
  }
  
  @media (max-width: 480px) {
    margin-left: 4px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const BackButton = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  background-color: #F5F5F5;
  margin-right: 24px;
  cursor: pointer;
  flex-shrink: 0;
  
  @media (${WIDTH.tabletWidth}) {
    width: 70px;
    height: 70px;
    border-radius: 16px;
    margin-right: 16px;
  }
  
  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    margin-right: 12px;
  }
  
  @media (max-width: 480px) {
    width: 56px;
    height: 56px;
    margin-right: 8px;
  }
`;

export const BackArrow = styled.img`
  width: 30px;
  height: 30px;
  
  @media (${WIDTH.tabletWidth}) {
    width: 26px;
    height: 26px;
  }
  
  @media (max-width: 768px) {
    width: 22px;
    height: 22px;
  }
  
  @media (max-width: 480px) {
    width: 20px;
    height: 20px;
  }
`;
